export default {
  BUILD_BOARD: 'BUILD_BOARD',
  FLIP: 'FLIP',
  SCORE: 'SCORE',
};



// WEBPACK FOOTER //
// ./src/actionTypes.js